import { Flex, Text, Box } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import cocacola_logo from "../../assets/img/org_Logo.png";

export function OrgIndiaLogo({ isExpanded = true }) {
  return (
    <Flex
      w={isExpanded ? "260px" : "70px"}
      h={isExpanded ? "45px" : "35px"}
      align="center"
      border="1px solid #dcdcdc"
      overflow="hidden"
      borderRadius="6px"
      justify="center"
      margin="auto"
    >
      {/* ORG Section */}
      <Box
        bg="#082fa2ff"
        h="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flex={isExpanded ? 1 : "none"}
        px={isExpanded ? 3 : 2}
        width={isExpanded ? "50%" : "100%"}
      >
        <Text
          fontSize={isExpanded ?
            { base: "16px", sm: "18px", md: "20px" } :
            { base: "12px", sm: "13px", md: "14px" }
          }
          fontWeight="bold"
          color="white"
          letterSpacing="0.5px"
          lineHeight="1"
          textAlign="center"
        >
          ORG
        </Text>
      </Box>

      {/* india Section (show only if expanded) */}
      {isExpanded && (
        <Box
          bg="white"
          h="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex={1}
          px={3}
          width="50%"
        >
          <Text
            fontSize={{ base: "16px", sm: "18px", md: "20px" }}
            fontWeight="medium"
            color="#02258eff"
            letterSpacing="0.5px"
            lineHeight="1"
            textAlign="center"
          >
            india
          </Text>
        </Box>
      )}
    </Flex>
  );
}


export default function OrgLogo({ isExpanded = true }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="transparent"
      w={
        isExpanded
          ? { base: "120px", sm: "140px", md: "250px" }
          : { base: "40px", sm: "45px", md: "65px" }
      }
      h={
        isExpanded
          ? { base: "40px", sm: "50px", md: "60px" }
          : { base: "30px", sm: "35px", md: "40px" }
      }
      position="relative"
    >
      <Image
        src={cocacola_logo}
        alt="Org Logo"
        objectFit="contain"
        w="100%"
        h="100%"
        position="absolute"
        top="0"
        left="0"
      />
    </Box>
  );
}
